import { BaseButton, buttonColorCSS } from '@procurify/ui'
import { em } from 'polished'
import styled, { css } from 'styled-components'

export const FilterButtonStyled = styled(BaseButton)`
  ${(props) => {
    const button = props.theme.colors.button.filter

    return css`
      ${buttonColorCSS(button, {
        loader: {
          background: button.background.hover,
          color: button.content.disabled,
        },
      })}
      box-shadow: none;
      font-weight: normal;
      border-radius: ${props.theme.typography.pxToRem(
        props.theme.shape.borderRadius
      )};
      height: ${em(38, props.theme.fontSizes.button)};

      &:hover,
      &:active {
        box-shadow: none;
      }
    `
  }}
`
